export const AppRoutesEnum = {
    BASE: '',

    ERROR: '/error',

    TL_HUB: '/tl-hub',
    TL_HUB_INSTITUTION_LISTING: '/tl-hub/institution-listing',
    TL_HUB_INSTITUTION_DETAILS: '/tl-hub/institution-details',

    GROUPS: '/groups',
    GROUPS_LISTING: '/groups/listing',
    FEE_WAIVERS_BULK_EDIT: '/groups/bulk-edit-fee-waivers',
    GROUP_GENERAL_SETTINGS: '/groups/group/general-settings',
    GROUP_MEMBERS: '/groups/group/members',
    GROUPS_FEE_WAIVERS: '/groups/fee-waivers',
    GROUP_FEE_WAIVERS: '/groups/group/fee-waivers',
};
